<div class="absolute bottom-3">
    <div
        id="custom-scale-container"
        [class]="customScaleStyle()">
        <div id="custom-scale-label">{{ scaleLabel() }}</div>
        <div id="custom-scale"></div>
    </div>
</div>
